import React from 'react'
import { connect } from 'react-redux'
import {Helmet} from 'react-helmet';

import { setUser, setSignin, setRoute, setToken } from '../../actions/user-action'
import { setWebsite } from '../../actions/website-action'

import {Grid, Row, Col, Button, FormControl} from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { store } from '../../store';

import LoadingBar from 'react-redux-loading-bar'

import Rolling from '../../Images/rolling.svg';

const mapStateToProps = (state) => {
  let user = state.user.user;
  let isSignedIn = state.user.isSignedIn;
  let website = state.website;
  let route = state.user.route;
  return {
    user: user,
    website: website,
    isSignedIn: isSignedIn,
    route: route
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUser: (user) => dispatch(setUser(user)),
    onSignin: (signin) => dispatch(setSignin(signin)),
    onWebsite: (website) => dispatch(setWebsite(website)),
    onRouteChange: (route) => dispatch(setRoute(route)),
    onToken: (token) => dispatch(setToken(token))
}
}

class Signin extends React.Component {
	constructor() {
		super()
		this.state = {
			key: '',
			password: '',
			status: '',
			error: '',
			tokenValid: false
		}
	}
	componentDidMount() {
		if(!this.state.tokenValid && store.getState().user.isSignedIn) {
			fetch(`${process.env.REACT_APP_API}/valid`, {
	          method: 'post',
	          headers: {'Content-Type': 'application/json'},
	          body: JSON.stringify({
	          username: store.getState().user.user.username,
	          token: store.getState().user.token
	          })
	        })
        	.then((response)=> {
	          response.json()
	          .then((data)=>{
	            if(data.auth === "false") {
	            	this.setState({tokenValid: false})
	            }
	          })
        })
    }
    if(store.getState().user.user !== null)
    this.setState({key: store.getState().user.user.username})
	}
	render() {
let { onRouteChange, onUser, onWebsite, onSignin, onToken } = this.props
const _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onButton()
    }
  }
const signinSuccess = (signin, user, website, route) =>  {
	this.setState({status: 'processing'})
	fetch(`${process.env.REACT_APP_API}/signin`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      user: {
      	key: this.state.key,
      	password: this.state.password
        }
    })
    })
      .then(response => {
      	response.json()
      	.then(signin => {
        if (signin.auth) {
          	onUser(signin.user)
          	onWebsite(signin.website)
          	onSignin('true')
			onToken(signin.token)
			onRouteChange('dashboard')
			this.setState({status: 'success'})
		}
		else if(signin.user === 'deactivated') {
			this.setState({error: 'deactivated'})
			this.setState({status: ''})
		}
		else if(signin.user === "banned") {
			this.setState({error: 'banned'})
			this.setState({status: ''})
		}
		else {
			this.setState({error: 'error'})
			this.setState({status: ''})
		}
      })
      })
}
const onButton = () => {
	if(!this.state.key || !this.state.password) {
		this.setState({error: 'empty'})
	}
   	else if(this.state.status === '')
   	return signinSuccess()
   	else return null
}
let logmsg = null
if(store.getState().user.isSignedIn)
	return window.location = '/'
if(this.state.status === 'success') {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    2000
			)
			}
	if(this.state.error) {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    800
			)
			}
      return (
      	<div
	        	onKeyDown={_handleKeyPress}>
        	<Helmet>
        	<title>Sign in</title>  
	          <meta name="description" content="Sign in & create beautiful profile site for free in less than two minutes" />
	          <meta name="keyword" content="sign in vieww, vieww profile, build profile page, sign in to profile" />
		      <meta property="og:type" content="website" />
	          <meta property="og:url" content="https://app.vieww.me/signin" />
	          <meta property="og:title" content="Sign in" />
	          <meta name="og:description" content="Sign in & create beautiful profile site for free in less than two minutes" />
	          <meta property="og:site_name" content="Sign in" />
	          <meta property="twitter:card" content="summary_large_image" />
		      <meta name="robots" content="index, follow" />
        	</Helmet>
	        <Grid fluid={true} className="form_bg">
	        <Row className="form form_inside">
	        <Col lg={6} md={8} sm={10} xs={12} className="form_inside_main">
	        <div className="form_in_main">
          	<Link to={'/'}><span href='#' className="go_back go_back_b"/></Link>
	        <h3 className="temp_headings black_color">Sign in</h3>
	        {this.state.error === 'empty'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Enter username & password</span></div></div>
            : null
          	}
          	{this.state.error === 'error'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Wrong username or password</span></div></div>
            : null
          	}
          	{this.state.error === 'banned'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Your account is temporarily banned, please check your mail for more details</span></div></div>
            : null
          	}
          	<br />
	        <FormControl  
	        	className="form_inp"
	        	type="text" 
	        	name="key" 
	        	placeholder="Username/Email" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.key}
	        	onChange={(e)=>this.setState({key: e.target.value.toLowerCase()})}
	        />
	        <br/>

	        <FormControl  
	        	className="form_inp"
	        	type="password" 
	        	name="password" 
	        	placeholder="Password" 
	        	onFocus={()=> this.setState({error: ''})}
	        	value={this.state.password}
	        	onChange={(e)=>{
	        		this.setState({password: e.target.value})
	        	}}
	        />
	        <br /><br />
	        <Button onClick={onButton.bind()} className="btn_new form_btn">
	        {this.state.status === 'processing'
	      	?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
	      	: null
	 		}
	 		{this.state.status === ''
	      	?<span>Signin</span>
	      	: null
	 		}
	        </Button>
	        <br /><br />
	        <Link to="/create" >Don't have a profile yet? Create one</Link>
	        </div>
	        </Col>
	        <Col lg={6} md={8} sm={10} xs={12} className="form_inside_img_outer">
	        <div className="form_inside_img">
	        <img className="form_inside_img_src" src="/assets/img/signin_image.svg" alt="signin_side_img"/>
	        </div>
	        </Col>
	        </Row>
	        </Grid>

	    </div>
      )
}
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);